import React from 'react'
import useUser, { isAuthorizedUser } from 'shared/hooks/use-user'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { getProfilePageLayout } from 'modules/profile/layouts/get-profile-page-layout'
import UserDomainAccountSettings from 'modules/profile/user-settings/components/user-domain-account-settings'
import Settings from 'modules/profile/user-settings/components/user-settings'
import UserSettingsSkeleton from 'modules/profile/user-settings/components/user-settings-skeleton'

function UserSettings() {
  const { user } = useUser()

  if (!user) {
    return <UserSettingsSkeleton />
  }

  return isAuthorizedUser(user) && user.isDomainOwner ? <UserDomainAccountSettings /> : <Settings />
}

UserSettings.getLayout = getProfilePageLayout

export const getServerSideProps = withDomainAssets(baseServerSideProps)

export default UserSettings
